import { createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mb-4" }
const _hoisted_2 = { class: "d-flex align-items-start " }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "pi pi-chevron-left mr-1" }, null, -1)
const _hoisted_4 = { class: "mt-2" }
const _hoisted_5 = {
  key: 0,
  class: "ml-auto d-flex align-items-center "
}
const _hoisted_6 = { class: "btn-stripped d-flex align-items-center w-100" }
const _hoisted_7 = { class: "btn-stripped d-flex align-items-center w-100" }
const _hoisted_8 = { class: "btn-stripped d-flex align-items-center w-100" }
const _hoisted_9 = { class: "text-danger" }
const _hoisted_10 = { class: "fs-18 text-gray" }
const _hoisted_11 = {
  key: 1,
  class: "py-5 text-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")
  const _component_Button = _resolveComponent("Button")
  const _component_ElDropdownItem = _resolveComponent("ElDropdownItem")
  const _component_ElDropdownMenu = _resolveComponent("ElDropdownMenu")
  const _component_ElDropdown = _resolveComponent("ElDropdown")
  const _component_DeviceObjectGroup = _resolveComponent("DeviceObjectGroup")
  const _component_DialogRenameGate = _resolveComponent("DialogRenameGate")
  const _component_DialogConfirmDeleteGate = _resolveComponent("DialogConfirmDeleteGate")
  const _component_DialogWarning = _resolveComponent("DialogWarning")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("header", _hoisted_1, [
      _createVNode("div", _hoisted_2, [
        _createVNode("div", null, [
          _createVNode(_component_router_link, {
            to: _ctx.backLink,
            class: "fs-18 text-decoration-none text-gray"
          }, {
            default: _withCtx(() => [
              _hoisted_3,
              _createTextVNode(" " + _toDisplayString(_ctx.$t("general.backTo")) + ": " + _toDisplayString(_ctx.currentEntrancePlant.name), 1)
            ]),
            _: 1
          }, 8, ["to"]),
          _createVNode("h1", _hoisted_4, _toDisplayString(_ctx.currentGate?.name), 1)
        ]),
        (!_ctx.adminView)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              (_ctx.gateEditEnabled)
                ? (_openBlock(), _createBlock(_component_ElDropdown, {
                    key: 0,
                    trigger: "click",
                    placement: "bottom-end",
                    "popper-class": "el-dropdown__popper el-dropdown--context"
                  }, {
                    dropdown: _withCtx(() => [
                      _createVNode(_component_ElDropdownMenu, { style: {"width":"300px"} }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ElDropdownItem, {
                            disabled: _ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                            onClick: _ctx.toggleConfigureGateDialog
                          }, {
                            default: _withCtx(() => [
                              _createVNode("button", _hoisted_6, [
                                _createVNode("span", null, _toDisplayString(_ctx.$t("AppResource.Edit")), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]),
                          _createVNode(_component_ElDropdownItem, {
                            disabled: _ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                            onClick: _ctx.showRenameGateDialog
                          }, {
                            default: _withCtx(() => [
                              _createVNode("button", _hoisted_7, [
                                _createVNode("span", null, _toDisplayString(_ctx.$t("AppResourceEP.Rename")), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]),
                          _createVNode(_component_ElDropdownItem, {
                            disabled: _ctx.currentEntrancePlant.syncStatus?.isPlantActive,
                            onClick: _ctx.toggleDeleteGateConfirm
                          }, {
                            default: _withCtx(() => [
                              _createVNode("button", _hoisted_8, [
                                _createVNode("span", _hoisted_9, _toDisplayString(_ctx.$t("AppResource.Delete")), 1)
                              ])
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"])
                        ]),
                        _: 1
                      })
                    ]),
                    default: _withCtx(() => [
                      _createVNode(_component_Button, { class: "p-button-text p-button-secondary p-1" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_InlineSvgScoped, {
                            src: 
                                require('@/assets/images/icons/icon-ellipsis-v.svg')
                            ,
                            "aria-label": "icon-ellipsis-v"
                          }, null, 8, ["src"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_10, _toDisplayString(_ctx.$t("AppResource.ConfigurationToEnd")) + ": " + _toDisplayString(_ctx.countConfigurationToEnd), 1)
    ]),
    (_ctx.hasDevices)
      ? (_openBlock(true), _createBlock(_Fragment, { key: 0 }, _renderList(_ctx.gateDevices, (device) => {
          return (_openBlock(), _createBlock(_component_DeviceObjectGroup, {
            key: device.deviceId,
            name: device.deviceId,
            device: device,
            gate: _ctx.currentGate,
            class: "mt-3",
            hideConfig: true,
            disableActions: true
          }, null, 8, ["name", "device", "gate"]))
        }), 128))
      : (_openBlock(), _createBlock("div", _hoisted_11, [
          _createVNode("h1", null, _toDisplayString(_ctx.$t("entrancePlant.gates.detail.noDevices")), 1)
        ])),
    _createVNode(_component_DialogRenameGate, {
      isVisible: _ctx.isVisibleRenameGateDialog,
      gateToEdit: _ctx.currentGate,
      onHideDialog: _ctx.hideRenameGateDialog,
      onUpdateList: _ctx.handleUpdateList
    }, null, 8, ["isVisible", "gateToEdit", "onHideDialog", "onUpdateList"]),
    _createVNode(_component_DialogConfirmDeleteGate, {
      isVisible: _ctx.isVisibleDeleteGateConfirm,
      onHideDialog: _ctx.toggleDeleteGateConfirm,
      onOkDialog: _ctx.deleteGate
    }, null, 8, ["isVisible", "onHideDialog", "onOkDialog"]),
    _createVNode(_component_DialogWarning, {
      message: _ctx.$t('entrancePlant.deleteGateWithDevicesMessage'),
      isVisible: _ctx.isVisibleDeleteGateWithDevicesWarning,
      onHideDialog: _ctx.toggleDeleteGateWithDevicesWarning
    }, null, 8, ["message", "isVisible", "onHideDialog"])
  ], 64))
}